"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.unionListToStatusData = exports.unionToStatusData = exports.StatusData = void 0;
const status_public_network_js_1 = require("../../solarxr-protocol/rpc/status-public-network.js");
const status_steam_vrdisconnected_js_1 = require("../../solarxr-protocol/rpc/status-steam-vrdisconnected.js");
const status_tracker_error_js_1 = require("../../solarxr-protocol/rpc/status-tracker-error.js");
const status_tracker_reset_js_1 = require("../../solarxr-protocol/rpc/status-tracker-reset.js");
const status_unassigned_hmd_js_1 = require("../../solarxr-protocol/rpc/status-unassigned-hmd.js");
var StatusData;
(function (StatusData) {
    StatusData[StatusData["NONE"] = 0] = "NONE";
    StatusData[StatusData["StatusTrackerReset"] = 1] = "StatusTrackerReset";
    StatusData[StatusData["StatusTrackerError"] = 2] = "StatusTrackerError";
    StatusData[StatusData["StatusSteamVRDisconnected"] = 3] = "StatusSteamVRDisconnected";
    StatusData[StatusData["StatusUnassignedHMD"] = 4] = "StatusUnassignedHMD";
    StatusData[StatusData["StatusPublicNetwork"] = 5] = "StatusPublicNetwork";
})(StatusData = exports.StatusData || (exports.StatusData = {}));
function unionToStatusData(type, accessor) {
    switch (StatusData[type]) {
        case 'NONE': return null;
        case 'StatusTrackerReset': return accessor(new status_tracker_reset_js_1.StatusTrackerReset());
        case 'StatusTrackerError': return accessor(new status_tracker_error_js_1.StatusTrackerError());
        case 'StatusSteamVRDisconnected': return accessor(new status_steam_vrdisconnected_js_1.StatusSteamVRDisconnected());
        case 'StatusUnassignedHMD': return accessor(new status_unassigned_hmd_js_1.StatusUnassignedHMD());
        case 'StatusPublicNetwork': return accessor(new status_public_network_js_1.StatusPublicNetwork());
        default: return null;
    }
}
exports.unionToStatusData = unionToStatusData;
function unionListToStatusData(type, accessor, index) {
    switch (StatusData[type]) {
        case 'NONE': return null;
        case 'StatusTrackerReset': return accessor(index, new status_tracker_reset_js_1.StatusTrackerReset());
        case 'StatusTrackerError': return accessor(index, new status_tracker_error_js_1.StatusTrackerError());
        case 'StatusSteamVRDisconnected': return accessor(index, new status_steam_vrdisconnected_js_1.StatusSteamVRDisconnected());
        case 'StatusUnassignedHMD': return accessor(index, new status_unassigned_hmd_js_1.StatusUnassignedHMD());
        case 'StatusPublicNetwork': return accessor(index, new status_public_network_js_1.StatusPublicNetwork());
        default: return null;
    }
}
exports.unionListToStatusData = unionListToStatusData;
